<div class="modal-header" *ngIf="data?.saleMemberAccessId">
  <h4 class="modal-title" id="modal-basic-title">Request Sale Access</h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="modal.dismiss('Cross click')"
  ></button>
</div>

<div [class]="containerClass" *ngIf="inviteWithdrawn">
  <div class="main-title">This invitation link is no longer in use</div>
  <p class="mt-3">
    Sale invitations have been withdrawn. To see or submit to a sale, sign in,
    open the sale and request access; the sales company will review your request.
  </p>
  <a routerLink="/" class="link-to-join">Go to sign in</a>
</div>

<div [class]="containerClass" *ngIf="!inviteWithdrawn">
  <div class="sub-title">
    {{ saleGranted?.description }}
  </div>
  <div class="greeting">Hi {{ saleGranted?.invitedTo }},</div>
  <div class="main-title">
    {{ saleGranted?.title }}
    <!--<i class="fa fa-spinner fa-spin" *ngIf="isLoader"></i>-->
  </div>
  <div class="invited-by">
    Invited by {{ saleGranted?.invitedBy }} ({{ saleGranted?.invitedByEmail }})
  </div>

  <div class="Permission-Type-Stat w-75 mb-3">
    <span><strong>Permission Type</strong></span
    ><span class="float-end">Status</span>
    <hr />
    <span><strong>Submit to Repository</strong></span
    ><span class="float-end" [hidden]="saleGranted?.isSubmissionAllowed"
      >Pending</span
    ><span class="float-end" [hidden]="!saleGranted?.isSubmissionAllowed"
      >Approved</span
    >
    <hr />
    <span><strong>View Repository</strong></span
    ><span class="float-end" [hidden]="saleGranted?.isViewingAllowed"
      >Pending</span
    ><span class="float-end" [hidden]="!saleGranted?.isViewingAllowed"
      >Approved</span
    >
    <hr />
  </div>
  <br />
  <button
    (click)="NavigateToRepo()"
    *ngIf="!data?.saleMemberAccessId"
    class="link-to-join"
  >
    View Repository
  </button>
  <div class="modal-footer" *ngIf="data?.saleMemberAccessId">
    <div class="button-group">
      <button (click)="NavigateToRepo()" class="link-to-join">
        View Repository
      </button>
    </div>
  </div>
</div>
